







import {Component, Prop, Vue} from 'vue-property-decorator';
import vSelect from 'vue-select';

interface SelectOption {
    label: string;
    value: string;
}

@Component({components: {vSelect}})
export default class MultiSelectControl extends Vue {
    @Prop({type: String, required: true})
    public readonly name: string;

    @Prop({type: Object, required: true})
    public readonly options: {[value: string]: string};

    @Prop({type: Array, required: true})
    public readonly values: string[];

    public selectedOptions: SelectOption[] = [];

    public get selectOptions(): SelectOption[] {
        return Object.entries(this.options).map(([key, value]) => ({label: value, value: key}));
    }

    public created(): void {
        this.selectedOptions = this.selectOptions.filter(
            (option: SelectOption) => this.values.includes(option.value),
        );
    }
}
